<template>
  <div class="panel-body">
    <h4>Email</h4>

    <div class="row" style="margin-top: 25px">
      <div class="col-xs-12">
        <div class="form-group clearfix">
          <label class="col-sm-3 control-label">Activity report</label>
          <div class="col-sm-9">
            <fieldset id="report_activity">
              <div class="radio radio-info radio-inline">
                <input type="radio" value="option1" name="report_activity" disabled>
                <label > Daily </label>
              </div>
              <div class="radio radio-info radio-inline">
                <input type="radio" value="option1" name="report_activity" disabled>
                <label > Weekly </label>
              </div>
              <div class="radio radio-info radio-inline">
                <input type="radio"  value="option1" name="report_activity" checked>
                <label > Disable </label>
              </div>
            </fieldset>
          </div>
        </div>
        <div style="">
          <div>We build an activity report for you (number of searches, number of experts, replies to your mailins, etc.).</div>
          <div>If you do not have any activity, we won’t bother you with an empty email.</div>
        </div>
      </div>
    </div>

    <div class="row" style="margin-top: 25px">
      <div class="col-xs-12">
        <div class="form-group clearfix">
          <label class="col-sm-3 control-label">Notification report</label>
          <div class="col-sm-9">
            <fieldset id="report_unread_notification">

              <div class="radio radio-info radio-inline">
                <input type="radio"  value="option1" name="report_unread_notification" disabled>
                <label > Individual </label>
              </div>
              <div class="radio radio-info radio-inline">
                <input type="radio"  value="option1" name="report_unread_notification" disabled>
                <label > Daily </label>
              </div>
              <div class="radio radio-info radio-inline">
                <input type="radio"  value="option1" name="report_unread_notification" disabled>
                <label > Weekly </label>
              </div>
              <div class="radio radio-info radio-inline">
                <input type="radio"  value="option1" name="report_unread_notification" checked>
                <label > Disable </label>
              </div>
            </fieldset>
          </div>
        </div>
        <div style="">
          <div>We build a summary report of your unread notifications.</div>
        </div>
      </div>
    </div>

    <div class="row" style="margin-top: 25px">
      <div class="col-xs-12">
        <div class="form-group clearfix">
          <label class="col-sm-3 control-label">New question</label>
          <div class="col-sm-9">

            <fieldset id="new_question">
              <div class="radio radio-info radio-inline">
                <input type="radio"  value="option1" name="new_question" disabled>
                <label > Yes </label>
              </div>
              <div class="radio radio-info radio-inline">
                <input type="radio"  value="option1" name="new_question" checked>
                <label > no </label>
              </div>
            </fieldset>
          </div>
        </div>
        <div style="">
          <div>We send you a mail when a new question is created, updated, requires validation, etc.</div>
        </div>
      </div>
    </div>

    <div class="row" style="margin-top: 25px">
      <div class="col-xs-12">
        <div class="form-group clearfix">
          <label class="col-sm-3 control-label">Newsletter</label>
          <div class="col-sm-9">
            <fieldset id="newsletter">

              <div class="radio radio-info radio-inline">
                <input type="radio"  value="option1" name="newsletter" checked="">
                <label > Yes </label>
              </div>
              <div class="radio radio-info radio-inline">
                <input type="radio"  value="option1" name="newsletter" checked="">
                <label > no </label>
              </div>
            </fieldset>
          </div>
        </div>
        <div style="">
          <div>We send a newsletter once in a while with new features or Open Innovation key information.</div>
        </div>
      </div>
    </div>

    <h4 style="margin-top: 25px">Notifications</h4>

    <div class="row" style="margin-top: 25px">
      <div class="col-xs-12">
        <div class="form-group clearfix">
          <label class="col-sm-3 control-label">New Project (broker)</label>
          <div class="col-sm-9">
            <fieldset id="new_project">

              <div class="radio radio-info radio-inline">
                <input type="radio"  value="option1" name="new_project" disabled>
                <label > Enable </label>
              </div>
              <div class="radio radio-info radio-inline">
                <input type="radio"  value="option1" name="new_project" checked>
                <label > Disable </label>
              </div>
            </fieldset>
          </div>
        </div>
        <div style="">
          <div>A notification is sent when a project is without supervising broker</div>
        </div>
      </div>
    </div>

    <div class="row" style="margin-top: 25px">
      <div class="col-xs-12">
        <div class="form-group clearfix">
          <label class="col-sm-3 control-label">New Question (broker)</label>
          <div class="col-sm-9">
            <fieldset id="new_question_notification">
              <div class="radio radio-info radio-inline">
                <input type="radio"  value="option1" name="new_question_notification" disabled>
                <label > Enable </label>
              </div>
              <div class="radio radio-info radio-inline">
                <input type="radio"  value="option1" name="new_question_notification" checked>
                <label > Disable </label>
              </div>
            </fieldset>
          </div>
        </div>
        <div style="">
          <div>A notification is sent when a question is created without any supervising broker.</div>
        </div>
      </div>
    </div>

    <div class="row" style="margin-top: 25px">
      <div class="col-xs-12">
        <div class="form-group clearfix">
          <label class="col-sm-3 control-label">Question Status Changed</label>
          <div class="col-sm-9">
            <fieldset id="question_status_changed">

              <div class="radio radio-info radio-inline">
                <input type="radio"  value="option1" name="question_status_changed" disabled>
                <label > Enable </label>
              </div>
              <div class="radio radio-info radio-inline">
                <input type="radio"  value="option1" name="question_status_changed" checked>
                <label > Disable </label>
              </div>
            </fieldset>
          </div>
        </div>
        <div style="">
          <div>A notification is sent when the status of a question changes.</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'EmailNotificationSettings',
  props: ['user']
}
</script>



// WEBPACK FOOTER //
// src/components/user/EmailNotificationSettings.vue